import {React} from '../utils/thirdpartyComponents';
const SmallLoader = () => {
    return (
      <div className="cw-loader-overlay-sm align-items-center justify-content-center">
          <div className="cw-loader"></div>
      </div>
    );
  };
  
  export default SmallLoader;
  